<template>
    <v-container fluid class="pa-0">
        <v-row no-gutters class="py-1">
            <v-col cols="8" class="px-2">
                <slot name="name"></slot>
            </v-col>
            <v-col cols="2" class="px-2">
                <slot name="status"></slot>
            </v-col>
        </v-row>
        <v-row no-gutters class="py-1">
            <v-col cols="4" class="px-2">
                <slot name="building"></slot>
            </v-col>
            <v-col cols="4" class="px-2">
                <slot name="wing"></slot>
            </v-col>
        </v-row>
        <v-row no-gutters class="py-1">
            <v-col cols="4" class="px-2">
                <slot name="floor"></slot>
            </v-col>
            <v-col cols="4" class="px-2">
                <slot name="room"></slot>
            </v-col>
        </v-row>
        <v-row no-gutters class="py-1">
            <v-col cols="4" class="px-2">
                <slot name="visibility"></slot>
            </v-col>
            <v-col cols="4" class="px-2">
                <slot name="channelMapName"></slot>
                <slot name="channelMapId"></slot>
            </v-col>
            <v-col cols="4" class="px-2">
                <slot name="defaultChannel"></slot>
            </v-col>
        </v-row>
        <v-row no-gutters class="py-1">
            <v-col class="px-2">
                <slot name="tags"></slot>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
export default {
    name: 'SpaceFormLayout'
};
</script>
